
import React, {useState} from "react";
import Text from "../../helpers/text";

export default function TrackMuteButton({track}) {

    const [muted, setMuted] = useState(false)

    function setMute(flag){
        track.enabled = flag
        setMuted(!flag)
    }

    const text = {
        video : [Text.actions.hideMe, Text.actions.showMe],
        audio : [Text.actions.muteMe, Text.actions.unmuteMe]
    }

    const txt = text[track.kind][muted ? 1 : 0]

    return (
        <button className={track.enabled ? "btn enabled " + track.kind : "btn " + track.kind } onClick={ () => setMute(!track.enabled) } title={txt}>
            <span className="hidden">{txt}</span>
        </button>
    )
}